import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { api } from "../lib/api";

export default function FAQ() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    api.get("/faq").then(({ data }) => setItems(data)).catch(() => {});
  }, []);

  return (
    <section id="faq" className="py-24 sm:py-32 bg-[#FDFBF7]" data-testid="faq-section">
      <div className="max-w-5xl mx-auto px-6 sm:px-10 lg:px-16">
        <div className="text-center mb-14">
          <p className="eyebrow mb-6">Häufige Fragen</p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#2A332C] leading-[1.05]">
            Antworten auf das, <br />
            <span className="font-display-italic text-[#A66B56]">was dich beschäftigt</span>.
          </h2>
        </div>

        <div className="divide-y divide-[#5C6B5E]/15 border-y border-[#5C6B5E]/15">
          {items.map((item, idx) => {
            const isOpen = open === item.id;
            return (
              <motion.div
                key={item.id}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: idx * 0.05 }}
                data-testid={`faq-item-${idx}`}
              >
                <button
                  onClick={() => setOpen(isOpen ? null : item.id)}
                  className="w-full flex items-center justify-between text-left py-7 gap-6 group"
                  data-testid={`faq-toggle-${idx}`}
                >
                  <span className="font-display text-xl sm:text-2xl text-[#2A332C] group-hover:text-[#A66B56] transition-colors">
                    {item.question}
                  </span>
                  <span className="flex-shrink-0 w-10 h-10 rounded-full border border-[#5C6B5E]/30 flex items-center justify-center text-[#5C6B5E]">
                    {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35, ease: [0.2, 0.9, 0.3, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="text-[#5C6B5E] text-lg leading-relaxed pb-7 pr-16">{item.answer}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
